<template>
  <div class="">
    <card back tools toolsColumns>
      <template v-slot:header>
        <h3>مدیریت فاکــــتورها</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="container-fulid">
          <div v-if="$route.name == 'FactorManager'" class="row no-print">
            <div class="col-md-6 col-12">
              <small id="LblTblCostomer">مربوط به مشتری</small>
              <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResultTblCostomer"
                :rownumintable="3" :defaultvalue="DataAxios.tblCustomerId" :action="'TblCrmCombo/GetCostomerProduct'"
                :method="'POST'" :idinput="'TblCostomer'" :keyItem="'TblCostomer'" :disabled="false"
                :ClassProps="'required'"  :ActiveDelete="true">
              </SearchableCombo>
            </div>
            <div class="col-md-3 col-12">
              <small id="LblSerialId"> شماره سریال فاکتور </small>
              <input type="number" v-model="DataAxios.SerialId" class="form-control text-center" />
            </div>
            <div class="col-md-3 col-12">
              <small id="LblSerialId"> تاریخ ثبت فاکتور</small>
              <date-picker color="dimgray" input-class="required form-control text-center" v-model="DataAxios.IssueDate"
                clearable :editable="true" placeholder=" تاریخ ثبت فاکتور "></date-picker>
            </div>
            <div class="col-md-3 col-12">
              <small id="LbltblComboGrpId50" class="ml-2">
                وضعیت تایید حسابدار</small>
              <div class="form-control text-center">
                <div class="custom-control custom-switch">
                  <small id="LbltblComboGrpId50" class="ml-2">
                    تاییده شده
                  </small>
                  <input type="checkbox" class="custom-control-input InputText" id="Done"
                    v-model="DataAxios.IsConfirmFinancial" />
                  <label class="custom-control-label" for="Done"> </label>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-12" v-if="$IsAccess('SelectTypeFactor')">
              <small>نوع فاکتور</small>
              <select class="form-control text-center" v-model="DataAxios.TypeFactor">
                <option  :value="12">رسمی | غیر رسمی</option>
                <option selected :value="1">رسمی</option>
                <option :value="2">غیر رسمی</option>
              </select>
            </div>
            <div class="col-md-2 col-12">
              <button type="button" class="btn btn-success w-100 mt-4" @click="SearchFactor">
                <i class="fad fa-search ml-3"></i> جستجوی فاکتور
              </button>
            </div>
          </div>
          <hr v-if="$route.name == 'FactorManager'" />
          <div class="row px-3">
            <bnp-grid v-if="$store.state.renderComponentGrid" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :action="true">
              <template slot="action-slot" slot-scope="props">
                <a href="javascript:;" v-if="props.props.IsConfirmFinancial != 1" class="mr-2 badge no-print">
                  <h5>
                    <span class="fas fa-marker text-secondary hover-warning" @click="OnEdit(props.props)"
                      title="ویرایش"></span></h5>
                </a>

                <a href="javascript:;" class="mr-2 badge no-print">
                  <h6>
                    <span v-if="$route.name == 'FactorManager'" class="fad fa-info-circle hover-info"
                      @click="OnDetail(props.props)" title="جزئیات فاکتور"></span></h6>
                </a>

                <a href="javascript:;" class="mr-2 badge no-print" v-if="
                    (props.props.IsConfirmFinancial == false &&
                      $session.get('UserInfo').tblUserGrpId ==
                        props.props.tblUserGrpIdInsert) ||
                    $session.get('UserInfo').tblGrpId == 1 || $session.get('UserInfo').tblUserId==205245
                  ">
                  <h5>
                    <span class="fad fa-trash hover-danger" title="حذف" @click="remove(props.props)"></span></h5>
                </a>

                <a href="javascript:;" class="mr-2 badge no-print">
                  <h5>
                    <span class="fad fa-print hover-danger" @click="OnPrint(props.props)" title="چاپ"></span></h5>
                </a>
              </template>
              <template slot="CustomerCode" slot-scope="props">
                <a href="javascript:;" @click="GotoCustomerDetail(props.props)">{{ props.props.CustomerCode }}</a>
              </template>
            </bnp-grid>
          </div>
        </div>
      </template>
    </card>



    <modal v-if="$store.state.Modal" :InheritanceTheme="false" :IsFooter="true" :Size="'Lg'">
      <template v-slot:body>
        <div class="bg-light">
          <print-factor :propsFactor="DataAxiosCopy"></print-factor>
        </div>
      </template>

      <template v-slot:footer>
        <smal class="text-danger" v-if="DataAxiosCopy.IsConfirmFinancial == 1">این فاکتور توسط واحد مالی تایید و ثبت سند
          شده است.
        </smal>
        <smal v-if="DataAxiosCopy.IsConfirmFinancial == 1" class="text-danger">
          شماره فاکتور حسابداری : {{ DataAxiosCopy.DocNumber }}</smal>
        <smal  class="mr-3 text-dark" v-if=" DataAxiosCopy.IsConfirmFinancial == false && $IsAccess('btnAccessfinancial') ">شماره سند حسابداری </smal>
        <input type="number" placeholder="شماره سند حسابداری"
          class="form-control col-md-3 d-inline bg-light text-dark mr-3" dir="ltr" v-if="
            DataAxiosCopy.IsConfirmFinancial == false &&
            $IsAccess('btnAccessfinancial')
          " v-model="DataAxiosCopy.DocNumber" />
        <b-button id="submit" size="sm" variant="dark" class="mr-3" @click="IsSubmit()" v-if="
            DataAxiosCopy.IsConfirmFinancial == false &&
            $IsAccess('btnAccessfinancial')
          ">
          تایید توسط واحد حســــــــابداری
        </b-button>
        <b-button id="submit" size="sm" variant="danger" class="mr-3" @click="IsEdit()" v-if="
            DataAxiosCopy.IsConfirmFinancial == true &&
            $IsAccess('btnAccessfinancial') " >اصلاح شماره فاکتور</b-button>
            {{DataAxiosCopy}}
      </template>
    </modal>    <modal v-if="$store.state.Modal" :InheritanceTheme="false" :IsFooter="true" :Size="'Lg'">
      <template v-slot:body>
        <div class="bg-light">
          <print-factor :propsFactor="DataAxiosCopy"></print-factor>
        </div>
      </template>

      <template v-slot:footer>
        <smal class="text-danger" v-if="DataAxiosCopy.IsConfirmFinancial == 1">این فاکتور توسط واحد مالی تایید و ثبت سند
          شده است.
        </smal>
        <smal v-if="DataAxiosCopy.IsConfirmFinancial == 1" class="text-danger">
          شماره فاکتور حسابداری : {{ DataAxiosCopy.DocNumber }}</smal>
        <smal  class="mr-3 text-dark" v-if=" DataAxiosCopy.IsConfirmFinancial == false && $IsAccess('btnAccessfinancial') ">شماره سند حسابداری </smal>
        <input type="number" placeholder="شماره سند حسابداری"
          class="form-control col-md-3 d-inline bg-light text-dark mr-3" dir="ltr" v-if="
            DataAxiosCopy.IsConfirmFinancial == false &&
            $IsAccess('btnAccessfinancial')
          " v-model="DataAxiosCopy.DocNumber" />
        <b-button id="submit" size="sm" variant="dark" class="mr-3" @click="IsSubmit()" v-if="
            DataAxiosCopy.IsConfirmFinancial == false &&
            $IsAccess('btnAccessfinancial')
          ">
          تایید توسط واحد حســــــــابداری
        </b-button>
        <b-button id="submit" size="sm" variant="danger" class="mr-3" @click="IsEdit()" v-if="
            DataAxiosCopy.IsConfirmFinancial == true &&
            $IsAccess('btnAccessfinancial') " >اصلاح شماره فاکتور</b-button>
            {{DataAxiosCopy}}
      </template>
    </modal>
  </div>
</template>
<script>
  import Card from "../../../components/Card/Card.vue";
  import SearchableCombo from "../../../components/Combo/SearchableCombo.vue";
  import VuePersianDatetimePicker from "vue-persian-datetime-picker";
  import BnpGrid from "../../../components/BnpGrid/BnpGrid.vue";
  import PrintFactor from "../../print/PrintFactor.vue";
  import Modal from "../../Modal/Modal.vue";

  export default {
    components: {
      Card,
      SearchableCombo,
      datePicker: VuePersianDatetimePicker,
      BnpGrid,
      PrintFactor,
      Modal,
    },
    data() {
      return {
        DataAxios: {
          tblCustomerId: 0,
          IssueDate: "",
          SerialId: null,
          IsConfirmFinancial: false,
          TypeFactor: 1,
          DocNumber: null,
          TypeFactor:1
        },
        DataAxiosCopy: {
          tblCustomerId: 0,
          IssueDate: "",
          SerialId: null,
          IsConfirmFinancial: false,
          DocNumber: null,
        },
        Column: [],
        Rows: [],
        DataAxoisColumn: {
          ArryfildValue: {
            SoftwareId: 2,
            UserId: 1,
            FormName: "frmFactorManager",
            ShowView: 0,
          },
          Method: "post",
          Action: "ReadGridColumns",
        },
        RowsDetail: [],
        ColumnDetail: [{
            name: "CustomerName",
            label: "نام مشتری",
            visibility: true
          },
          {
            name: "ProductName",
            label: "نام محصول",
            visibility: true
          },
          {
            name: "TblContractId",
            label: "شمار قرارداد",
            visibility: true
          },
          {
            name: "Amount",
            label: "قیمت",
            visibility: true
          },
          {
            name: "SumTollTax",
            label: "مجموع ملیات و عوارض",
            visibility: true
          },
          {
            name: "Discount",
            label: "تخفیف",
            visibility: true
          },
          {
            name: "TotallAmount",
            label: "قیمت کل",
            visibility: true
          },
        ],
      };
    },
    methods: {
      GetResultTblCostomer(val) {
        this.DataAxios.tblCustomerId = val.id;
      },
      SearchFactor() {
        let DataAxios_Data = {
          ArryfildValue: {},
          Method: "post",
          Action: "Factor/FactorManager",
          Token: this.$session.get("Token"),
        };
        this.DataAxios.IssueDate += "";
        DataAxios_Data.ArryfildValue = this.DataAxios;
        this.$PostData(DataAxios_Data)
          .then((data) => {
            this.Rows = data;
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          });
      },
      getColumnGrid() {
        this.$GetColumns(this.DataAxoisColumn, true)
          .then((data) => {
            this.Column = data;
            this.Column.push({
              name: "tblContractsId",
              label: "شماره قرارداد",
              visibility: true,
            });
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          });
      },
      OnDetail(row) {
        let DataAxios_Data = {
          ArryfildValue: {},
          Method: "post",
          Action: "Factor/DetailFactor",
          Token: this.$session.get("Token"),
        };
        DataAxios_Data.ArryfildValue.Id = row.Id;
        this.$PostData(DataAxios_Data)
          .then((data) => {
            data.forEach((el) => {
              el["Miniaturize_AmountDiscount"] = el.AmountDiscount;
              el["Name"] = el.NameProduct;
              el["tblComboGrpId12"] = row.tblComboGrpId12;
            });
            this.DataAxios.tblShobeId = this.$session.get("UserInfo").tblShobeId;
            this.DataAxios.tblUserGrpIdInsert =
              this.$session.get("UserInfo").tblUserGrpId;
            this.DataAxios.tblFactorCustomerProducts = data;
            this.DataAxios["Description"] = row.Description;
            this.DataAxios["Id"] = row.Id;
            this.DataAxios.SerialId = row.SerialId;
            this.DataAxios.IssueDate = row.IssueDate;
            this.DataAxios["tblShobeId"] = row.tblShobeId;
            this.DataAxios["IsConfirmFinancial"] = row.IsConfirmFinancial;
            this.DataAxios["tblCustomerId"] = row.tblCustomerId;
            this.DataAxios["DocNumber"] = row.DocNumber;
            this.DataAxios["DateTimeLastEdit"]=row.DateTimeLastEdit
            // this.$router.push({name:"PrintFactor", params: {propsFactor:this.DataAxios } })
            // this.$bvModal.show('modal-Detail')
            this.DataAxiosCopy = JSON.parse(JSON.stringify(this.DataAxios));

            this.DataAxios = {
              tblCustomerId: null,
              IssueDate: "",
              SerialId: null,
              IsConfirmFinancial: false,
              DocNumber: 0,
              TypeFactor:1
            };
          })
          .finally(() => {
            this.$store.state.Modal = true;
          });
      },
      OnEdit(row) {
        let DataAxios_Data = {
          ArryfildValue: {},
          Method: "post",
          Action: "Factor/DetailFactor",
          Token: this.$session.get("Token"),
        };
        DataAxios_Data.ArryfildValue.Id = row.Id;
        this.$PostData(DataAxios_Data).then((data) => {
          this.$router.push({
            name: "Factor",
            params: {
              Status: "Edit",
              propstblCustomerProducts: data,
              propsFactor: row,
            },
          });
        });
      },
      OnPrint(row) {
        let DataAxios_Data = {
          ArryfildValue: {},
          Method: "post",
          Action: "Factor/DetailFactor",
          Token: this.$session.get("Token"),
        };
        DataAxios_Data.ArryfildValue.Id = row.Id;
        this.$PostData(DataAxios_Data).then((data) => {
          data.forEach((el) => {
            console.warn(el);
            el["Miniaturize_AmountDiscount"] = el.AmountDiscount;
            el["Name"] = el.NameProduct;
            el["tblComboGrpId12"] = row.tblComboGrpId12;
          });
          this.DataAxios.tblShobeId = this.$session.get("UserInfo").tblShobeId;
          this.DataAxios.tblUserGrpIdInsert =
            this.$session.get("UserInfo").tblUserGrpId;
          this.DataAxios.tblFactorCustomerProducts = data;
          this.DataAxios["Description"] = row.Description;
          this.DataAxios.SerialId = row.SerialId;
          this.DataAxios.IssueDate = row.IssueDate;
          this.DataAxios["tblShobeId"] = row.tblShobeId;
          this.DataAxios["tblCustomerId"] = row.tblCustomerId;
          this.$router.push({
            name: "PrintFactor",
            params: {
              propsFactor: this.DataAxios
            },
          });
        });
      },
      IsSubmit() {
        this.$SweetQustion(
          "اطمینان از تایید",
          "از تایید فاکتور خود اطمینان دارید؟ درصورت تایید فاکتور امکان لغو وجود ندارد",
          "warning",
          "تایید سند",
          "انصراف",
          this.DataAxiosCopy,
          this.SubmitSuccess,
          this.cancel
        );
      },
      IsEdit(row){
        row=this.DataAxiosCopy
        let DataAxios_UpdateData = {
            ArryfildValue: {},
            Method: "post",
            Action: "CustomerFinancialInvoice/ConfirmCustomerFinancialInvoice",
            Token: this.$session.get("Token"),
          }; 
          DataAxios_UpdateData.ArryfildValue.Id = row.Id;
          DataAxios_UpdateData.ArryfildValue.DocNumber = row.DocNumber;
          DataAxios_UpdateData.ArryfildValue.IsConfirmFinancial  = false ;
          this.$PostData(DataAxios_UpdateData)
            .then((data) => {
              if (data.status == "Ok") {
                this.SearchFactor();
                this.$toasted.success("فاکتور با موفقیت در حالت اصلاح قرار گرفت", {
                  action: {
                    text: "بستن",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                });
              }
            }).finally(() => {
              this.DataAxios.tblCustomerId =null
              this.DataAxiosCopy.IsConfirmFinancial=false
              this.$store.state.Modal=false
              this.$store.state.renderComponentGrid = false;
              this.$nextTick(() => {
                this.$store.state.Modal=true
                this.$store.state.renderComponentGrid = true;
              });
            });
      },
      SubmitSuccess(row) {
        if (row.DocNumber == null || row.DocNumber == 0) {
          this.$toasted.error(
            "شمار فاکتور حسابداری برای تایید فاکتور اجباری است", {
              action: {
                text: "بستن",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
            }
          );
          return;
        } else {
          let DataAxios_ArciveData = {
            ArryfildValue: {},
            Method: "post",
            Action: "CustomerFinancialInvoice/ConfirmCustomerFinancialInvoice",
            Token: this.$session.get("Token"),
          };
          DataAxios_ArciveData.ArryfildValue.Id = row.Id;
          DataAxios_ArciveData.ArryfildValue.DocNumber = row.DocNumber;
          DataAxios_ArciveData.ArryfildValue.IsConfirmFinancial  = true ;
          this.$PostData(DataAxios_ArciveData)
            .then((data) => {
              if (data.status == "Ok") {
                this.$store.state.Modal = false;
                 this.SearchFactor();
                this.$toasted.success("فاکتور با موفقیت تایید شد", {
                  action: {
                    text: "بستن",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                });
              }
            })
            .finally(() => {
              this.DataAxios.tblCustomerId =null
              this.DataAxiosCopy.IsConfirmFinancial=true
              this.$store.state.renderComponentGrid = false;
              this.$store.state.Modal=false
              this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true;
                this.$store.state.Modal=true
              });
            });
        }
      },
      GotoCustomerDetail(data) {
        this.$router.push({
          name: "DetailCustomer",
          params: {
            tblCustomerId: data.tblCustomerId
          },
        });
      },
      remove(row) {
        this.$SweetQustion(
          "اطمینان از حذف",
          "آیا از حذف فاکتور اطمینان دارید؟",
          "warning",
          "تایید حذف",
          "انصراف",
          row,
          this.RemoveFactor,
          this.cancel
        );
      },
      RemoveFactor(row) {
        let DataAxios_Data = {
          ArryfildValue: {},
          Method: "post",
          Action: "Factor/DeleteFactor",
          Token: this.$session.get("Token"),
        };
        DataAxios_Data.ArryfildValue.Id = row.Id;
        this.$PostData(DataAxios_Data).then((data) => {
          if (data == true) {
            this.$toasted.success("فاکتور حذف شد", {});
            this.SearchFactor();
          } else {
            this.$toasted.error("مشکل در حذف فاکتور", {});
          }
        });
      },
    },
    created() {
      this.$store.state.Modal = false;
      if (this.$route.name == "MyFactors") {
        let DataAxios_Data = {
          ArryfildValue: {},
          Method: "post",
          Action: "Factor/FactorManager",
          Token: this.$session.get("Token"),
        };
        this.DataAxios = {
          tblCustomerId: this.$session.get("CustomerInfo").Id,
          IssueDate: "",
          SerialId: null,
          IsConfirmFinancial: true,
          TypeFactor: 1,
          DocNumber: null,
        };
        this.DataAxios.IssueDate += "";
        DataAxios_Data.ArryfildValue = this.DataAxios;
        this.$PostData(DataAxios_Data)
          .then((data) => {
            this.Rows = data;
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          });
      }

      this.getColumnGrid();
    },
    mounted() {
      this.$GetAccessUser();
      console.log(this.$store.state.JalaliDate);
    },
    dispose() {},
  };
</script>
<style>
  @media print {
    .no-print {
      display: none;
    }
  }
</style>